import { render, staticRenderFns } from "./PageEditorContentNavContent.vue?vue&type=template&id=0ae32a6a&scoped=true"
import script from "./PageEditorContentNavContent.vue?vue&type=script&lang=js"
export * from "./PageEditorContentNavContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae32a6a",
  null
  
)

export default component.exports